import { Route } from '@angular/router';
import { AssignmentsComponent } from './assignments.component';
import { AssignmentsDetailComponent } from './assignments-detail/assignments-detail.component';
import { RequestsDetailComponent } from '@features/requests/requests-detail/requests-detail.component';

export const ASSIGNMENTS_ROUTES: Route[] = [
  {
    path: '',
    data: { name: 'Opdrachten' },
    children: [
      { path: '', component: AssignmentsComponent },
      {
        path: 'request/:id',
        component: RequestsDetailComponent,
        data: { name: 'Details', listPath: '/assignments' },
      },
      { path: ':id', component: AssignmentsDetailComponent, data: { name: 'Details' } },
    ],
  },
];
